import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

export interface ITimelineItem {
  text: string;
  secondaryText?: string;
  iconPath?: string;
  tooltipText?: string;
  nestedItems?: ITimelineItem[];
  infoTooltipText?: string;
  showLightningIcon?: boolean;
  lightningTooltipText?: string;
}

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
})
export class TimelineComponent {
  @Input() public timelineItems: ITimelineItem[] = [];
  @Input() public timelineItemsDescOrder = false;
  @Input() public withIcons = false;
  @Input() public violationMode = false;
}
